import { render, staticRenderFns } from "./SnTabsV2.vue?vue&type=template&id=7c75e998&scoped=true"
import script from "./SnTabsV2.vue?vue&type=script&lang=js"
export * from "./SnTabsV2.vue?vue&type=script&lang=js"
import style0 from "./SnTabsV2.vue?vue&type=style&index=0&id=7c75e998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c75e998",
  null
  
)

export default component.exports